module.exports = __webpack_public_path__ + "img/8.48f7530b.webp";